import type { ServiceOption } from '@/shared/storage-services-api';

/**
 * NEX-1165 — splits the depósito's part of the catalog (`getServiceOptions()`) by `kind` (NEX-1166):
 * services are what it offers and what a client asks for / filters by; conditions are what it
 * imposes, shown to the client next to the quote (business doc §4: "el usuario filtra por
 * servicios, las condiciones se muestran"). A storage type (`kind` 'storage_type') is neither, so it
 * never comes out of either function. Kept out of `storage-services-api.ts` so a page test that
 * stubs that transport module wholesale still gets the real split.
 */
export function serviceOptionsOnly(options: readonly ServiceOption[]): ServiceOption[] {
  return options.filter((option) => option.kind === 'service');
}

export function conditionOptionsOnly(options: readonly ServiceOption[]): ServiceOption[] {
  return options.filter((option) => option.kind === 'condition');
}
